import { createSlice } from "@reduxjs/toolkit";
import { getConfig } from "./systemDuck";

export const socketDefaultState = {
  isConnected: false,
  socket: null,
};

const socketSlice = createSlice({
  name: "socket",
  initialState: socketDefaultState,
  reducers: {
    closeSocket(state, action) {
      state.isConnected = false;
    },
  },
  extraReducers: (builder) => {
    // Check getConfig import from systemDuck returned undefined
    builder.addCase("system/getConfig", (state, action) => {
      state.isConnected = true;
    });
  },
});

export const { closeSocket } = socketSlice.actions;

export default socketSlice.reducer;
